import React from 'react';
import MyTooltip from './my-tooltip'

const Input = ({ name, onChange, id, label, error = false, horizontal = true, type = "text", disabled = false, tooltip = false, message = "", depend = null }) => {
    const inputClasses = error ? 'form-control is-invalid' : 'form-control';
    var divClass = '';
    var parentDiv = "form-group mt-4";
    var labelClasses = '';
    if (horizontal) {
        divClass = 'col-sm-9';
        labelClasses += ' col-sm-3 col-form-label'
        parentDiv += ' row';
    }

    return (
        <div className={parentDiv}>
            <label className={labelClasses}>
                {label}
                {tooltip && <MyTooltip name={name} message={message} />
                }
            </label>
            <div className={divClass}>
                <input onChange={onChange} disabled={disabled} data-depend={depend} name={name} id={id} type={type} className={inputClasses} />
            </div>
        </div>);
}

export default Input;